document.addEventListener("DOMContentLoaded", () => {
  // Apply Desktop/Mobile Color Scheme Depending on Window Size START
  const headerWithSchemes = document.querySelector('header div.js-schemes');
  const headerWithSchemesClassList = [...headerWithSchemes.classList];

  const mobileColorScheme = headerWithSchemesClassList.find(item => item.includes('mobile')).split('-').filter((item, index) => index != 0).join('-');
  const desktopColorScheme = headerWithSchemesClassList.find(item => item.includes('desktop')).split('-').filter((item, index) => index != 0).join('-');

  if (mobileColorScheme === desktopColorScheme) return;
  if (window.innerWidth <= 989) {
    headerWithSchemes.classList.remove(desktopColorScheme);
  } else {
    headerWithSchemes.classList.remove(mobileColorScheme);
  }

  window.addEventListener('resize', () => {
    if (mobileColorScheme === desktopColorScheme) return;
    if (window.innerWidth <= 989) {
      headerWithSchemes.classList.remove(desktopColorScheme);
      headerWithSchemes.classList.add(mobileColorScheme);
    } else {
      headerWithSchemes.classList.remove(mobileColorScheme);
      headerWithSchemes.classList.add(desktopColorScheme);
    }
  });
// Apply Desktop/Mobile Color Scheme Depending on Window Size END
})